import { makeUnexpectedFileContentError } from '../ParseError.js';
export class MusepackContentError extends makeUnexpectedFileContentError('Musepack') {
}
//# sourceMappingURL=MusepackConentError.js.map